import { jsx as _jsx } from "react/jsx-runtime";
import { es, pt } from "make-plural/plurals";
import { I18nProvider } from "@lingui/react";
import { i18n } from "@lingui/core";
import { messages as esMessages } from "./locales/es/messages";
import { messages as ptBRMessages } from "./locales/pt-BR/messages";
import React from "react";
const ElementsContext = React.createContext(null);
i18n.loadLocaleData({
    es: { plurals: es },
    "pt-BR": { plurals: pt },
});
i18n.load({
    es: esMessages,
    "pt-BR": ptBRMessages,
});
i18n.activate("es");
export const ElementsProvider = ({ children, context, isMobile = false, }) => {
    return (_jsx(ElementsContext.Provider, Object.assign({ value: { context, isMobile } }, { children: _jsx(I18nProvider, Object.assign({ i18n: i18n }, { children: children }), void 0) }), void 0));
};
export const useElementsContext = () => {
    const elementsContext = React.useContext(ElementsContext);
    if (!elementsContext) {
        // this is especially useful in TypeScript so you don't need to be checking for null all the time
        throw new Error("You have forgot to use ElementsProvider, shame on you.");
    }
    return elementsContext;
};
//# sourceMappingURL=elementsProvider.js.map